export default __webpack_public_path__ + "b437b95e004a18ce5ff6c1540284553c.png";